"use strict";
/**
 * @author: yangqianjun
 * @file: thanks for https://github.com/prisma-labs/graphql-request
 * @Date: 2019-10-30 16:38:27
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-27 13:35:19
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var qs_1 = tslib_1.__importDefault(require("qs"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var consts_1 = require("./consts");
var axios_2 = require("./axios");
/** 提取错误信息、错误码 */
function extractCodeAndMessage(errors) {
    return errors.reduce(function (res, _a) {
        var message = _a.message;
        if (typeof message === 'string') {
            res.message = (res.message ? res.message + "\n" : res.message) + message;
        }
        else {
            var error = message.error, statusCode = message.statusCode;
            if (statusCode === 401 || (statusCode === 403 && res.code !== 401)) {
                res.code = statusCode;
            }
            res.message += error + "\n";
        }
        return res;
    }, {
        code: consts_1.GraphQLErrorCode,
        message: ''
    });
}
exports.extractCodeAndMessage = extractCodeAndMessage;
var testUser = typeof location !== 'undefined' && qs_1.default.parse(location.search.split('?')[1]).testUser;
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, options) {
        this.url = url;
        this.options = options || {};
    }
    GraphQLClient.prototype.request = function (query, variables, opt
    // IMP: 兼容 new-ajax.ts 设计
    ) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, headers, others, body, config, cancel;
            return tslib_1.__generator(this, function (_b) {
                _a = this.options, headers = _a.headers, others = tslib_1.__rest(_a, ["headers"]);
                body = JSON.stringify({
                    query: query,
                    variables: variables ? variables : undefined
                });
                config = tslib_1.__assign({ url: this.url, method: 'POST', headers: tslib_1.__assign(tslib_1.__assign({ 'Content-Type': 'application/json' }, headers), (opt && opt.headers)), data: body }, others);
                if (testUser) {
                    config.headers['Test-User'] = testUser;
                }
                cancel = opt && opt.cancel;
                if (cancel) {
                    config.cancelToken = new axios_1.default.CancelToken(function (c) {
                        cancel.then(c, axios_2.emptyFunc);
                    });
                }
                return [2 /*return*/, axios_1.default.request(config).then(function (res) {
                        if (res.status === 200 && res.data && (!res.data.errors || !res.data.errors.length)) {
                            return {
                                code: 0,
                                result: res.data.data
                            };
                        }
                        return tslib_1.__assign({ result: res.data && res.data.data }, extractCodeAndMessage(res.data.errors || []));
                    }, axios_2.onStatusError)];
            });
        });
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
function request(url, query, variables, opt) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var client;
        return tslib_1.__generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.request(query, variables, opt)];
        });
    });
}
exports.request = request;
exports.default = request;
//# sourceMappingURL=graphql.js.map